package de.oevbs.kunde.kundenportal2.model.services.contact.types

import kotlinx.serialization.Serializable

@Serializable
enum class ComplaintSubject(val text: String = "", val key: Int = -1) {
    CONTRACT("Vertrag",1),
    LOSS_REGULATION("Schadenregulierung",2),
    MONITION("Mahnung",3),
    ADVISER_ONSITE("Betreuer vor Ort",4),
    HEADQUARTER("Zentrale",5),
    OTHER("Sonstiges",6)
}
